export const mental_params_mix = {
  data() {
    return {
      s2_settings: {
        multiple: false,
        minimumResultsForSearch: -1
      },
      formula_numbers: {
        0: {

        },
        5: {
          cifers_plus: [1, 2, 3, 4],
          cifers_minus: [-1, -2, -3, -4]
        },
        10: {
          cifers_plus: [1, 2, 3, 4, 5, 6, 7, 8, 9],
          cifers_minus: [-1, -2, -3, -4, -5, -6, -7, -8, -9],
        },
        '10-5': {
          cifers_dop_plus: [1, 2, 3, 4],
          cifers_dop_minus: [-1, -2, -3, -4],
          cifers_plus: [1, 2, 3, 4, 5, 6, 7, 8, 9],
          cifers_minus: [-1, -2, -3, -4, -5, -6, -7, -8, -9],
        },
        15: {
          cifers_plus: [6, 7, 8, 9],
          cifers_minus: [-6, -7, -8, -9]
        },
        '*': {},
      },
      rank_values: [
        {
          id: '1/9',
          text: 'от 1 до 9'
        },
        {
          id: '10/99',
          text: 'от 10 до 99'
        },
        {
          id: '100/999',
          text: 'от 100 до 999'
        },
        {
          id: '1/99',
          text: 'от 1 до 99'
        },
        {
          id: '10/999',
          text: 'от 10 до 999'
        },
        {
          id: '1/999',
          text: 'от 1 до 999'
        },
      ],
      select_formulas: [
        {
          id: '0',
          text: 'Прямой счет'
        },
        {
          id: '5',
          text: 'Формулы 5-ки'
        },
        {
          id: '10',
          text: 'Формулы 10-ки'
        },
        {
          id: '10-5',
          text: 'Формулы 5-ки и 10-ки'
        },
        {
          id: '15',
          text: 'Комбинации'
        },
        {
          id: '*',
          text: 'Микс'
        },
      ],
    }
  },
  props: {},
  computed: {
    checkEmptyCifers() {
      if (_.isEmpty(this.formula_numbers[this.params.formula])) {
        return false;
      } else {
        return true;
      }
    },
    current_formula() {
      return this.formula_numbers[this.params.formula];
    },
  },
  methods: {
    emptyVals() {
      this.params.cifers = [];
      //this.$parent.commitVal([], 'cifers');
    },
    addSpeed(val){
      let speed = +this.params.speed;
      if(val === '+' && speed < 10){
        speed += 0.1;
      } else if(val === '-' && speed > 0.1){
        speed -= 0.1;
      }

      this.params.speed = speed.toFixed(1);
    },
    addTerms(val){
      if(val === '+'){
        this.params.terms++;
      } else if(this.params.terms > 2){
        this.params.terms--;
      }
    },
    addUsers(val){
      if(val === '+' && this.users < 10){
        this.users++;
      } else if(val === '-' && this.users > 1){
        this.users--;
      }
    },
    addSteps(val){
      if(val === '+'){
        this.params.steps++;
      } else if(this.params.steps > 1){
        this.params.steps--;
      }
    },
    addQnt(val, param, param2) {
      if (!param2) {
        if (val === '+') {
          this.params[param]++;
        } else if (this.params[param] > 1) {
          this.params[param]--;
        }
      } else {
        if (val === '+') {
          this.params[param][param2]++;
        } else if (this.params[param][param2] > 1) {
          this.params[param][param2]--;
        }
      }
    },
    clickCheck(event, val, type) {
      console.log('Click check');
      let cifers = this.current_formula[val];
      let n_cif;
      if (type === 'main') {
        n_cif = this.params.cifers;
      } else {
        n_cif = this.params.cifers_dop;
      }
      let intersect = _.intersection(n_cif, cifers);
      if (intersect.length === 0) {
        n_cif = _.concat(n_cif, cifers);
        $(event.target).addClass('active');
      } else {
        n_cif = _.filter(n_cif, function (o) {
          return _.indexOf(intersect, o) === -1;
        });
        $(event.target).removeClass('active');
      }

      if (type === 'main') {
        this.params.cifers = n_cif;
      } else {
        this.params.cifers_dop = n_cif;
      }


      //let current_trainer = this.
      //console.log(cifers);
    }
  },

  mounted() {
  }
};